import styled from 'styled-components'
import { ListItem } from 'components/list'
import { flexColumnsCss } from 'components/flex'

export const PersonItem = ListItem

export const PersonColumns = styled.label`
    ${flexColumnsCss}

    column-gap: 16px;
    align-items: center;

    height: 40px;

    label&:not(.disabled) {
        cursor: pointer;
    }
`